module.exports = {"542422100":"阿扎镇","542422101":"嘉黎镇","542422200":"鸽群乡","542422201":"藏比乡","542422202":"忠玉乡","542422203":"措多乡","542422204":"措拉乡","542422205":"林堤乡","542422206":"夏玛乡","542422207":"绒多乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542422.json
// module id = 2895
// module chunks = 0